import { render } from "./NewInteractionModal.vue?vue&type=template&id=52b8ff68&scoped=true"
import script from "./NewInteractionModal.vue?vue&type=script&lang=js"
export * from "./NewInteractionModal.vue?vue&type=script&lang=js"

import "./NewInteractionModal.vue?vue&type=style&index=0&id=52b8ff68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b8ff68"],['__file',"NewInteractionModal.vue"]])

export default __exports__